import React from 'react';

import Illustration from './Illustration';
import BlockContent from './BlockContent';
import Button from './Button';

export default function TypologyCard({ section }) {
  const {
    illustration,
    blockContent,
    blockContent: { buttons },
    isDarkMode
  } = section || {};
  return (
    <>
      {section && (
        <Button button={buttons[0]}>
          <div className={`typology-card ${isDarkMode ? '--dark' : ''}`}>
            <Illustration illustration={illustration} />
            <BlockContent content={blockContent} />
          </div>
        </Button>
      )}
    </>
  );
}
